import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useSearch } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import ChooseWorkspace from '@/components/createWorkspace/ChooseWorkspace'
import CompleteWorkspace from '@/components/createWorkspace/CompleteWorkspace'
import CreateWorkspace from '@/components/createWorkspace/CreateWorkspace'
import { Button } from '@/components/ui'

export const Route = createFileRoute('/(protected)/workspaces/new')({
  component: WorkspaceNew,
  validateSearch: (search: Record<string, unknown>) => {
    const normalizedStep =
      typeof search.step === 'number'
        ? search.step
        : typeof search.step === 'string'
          ? Number(search.step) || 2
          : 2

    const normalizedType =
      typeof search.type === 'string' && search.type.length > 0
        ? search.type
        : 'blank'

    return {
      step: normalizedStep,
      type: normalizedType,
      notionKey: typeof search.notionKey === 'string' ? search.notionKey : undefined,
      workspaceName: typeof search.workspaceName === 'string' ? search.workspaceName : undefined,
    }
  },
  beforeLoad: () => {
    return {
      skipParentLayout: true,
    }
  },
})

function WorkspaceNew() {
  const navigate = useNavigate()
  const { step } = useSearch({ from: '/(protected)/workspaces/new' })

  const goBack = () => {
    navigate({ to: '/' })
  }

  return (
    // <LoginLayout>
    //   <div className='w-full'>
    //     <Card className='LoginLayout border-none !bg-transparent py-0 shadow-none'>
    //       <CardHeader className='gap-3 px-0'>
    //         <CardTitle className='text-2xl leading-6'>
    //           Create a new workspace
    //         </CardTitle>
    //         <CardDescription>
    //           A workspace helps you organize your documentation.
    //         </CardDescription>
    //       </CardHeader>
    //       <CardContent className='px-0'>
    //         <WorkspaceForm onSuccess={onWorkspaceCreateSuccess} />
    //       </CardContent>
    //     </Card>
    //   </div>
    // </LoginLayout>

    <div className='bg-background max-w relative flex h-dvh w-dvw flex-col items-center justify-center'>
      <Button
        variant='ghost'
        size='icon'
        className='absolute top-4 left-4'
        onClick={goBack}
      >
        <ArrowLeft size={16} />
      </Button>
      {/* <h1 className='mb-2 text-center text-2xl leading-8 font-semibold'>
        Choose how to start your workspace
      </h1>
      <p className='text-muted-foreground mb-12 text-center text-lg leading-7 font-semibold'>
        Create a workspace to manage your documentation more efficiently
      </p>
      <div className='flex w-full justify-center gap-5'>
        <div className='w-[250px] cursor-pointer rounded-md border p-5'>
          <BookOpen size={28} />
          <h6 className='mt-4 mb-1 text-sm leading-5 font-semibold'>
            Blank workspace
          </h6>
          <p className='text-muted-foreground my-0 text-xs leading-4'>
            Create a workspace from scratch.
          </p>
        </div>
        <div className='w-[250px] cursor-pointer rounded-md border p-5'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='28'
            height='28'
            viewBox='0 0 28 28'
            fill='none'
          >
            <path
              d='M17.4649 0.934675L2.89641 2.00741C1.72218 2.10891 1.31268 2.87452 1.31268 3.79238V19.7154C1.31268 20.4302 1.56818 21.0419 2.18154 21.8591L5.60624 26.2988C6.16886 27.0136 6.67985 27.1668 7.75433 27.116L24.6722 26.0949C26.1028 25.9934 26.5123 25.3293 26.5123 24.2067V6.29309C26.5123 5.71297 26.2822 5.54585 25.6049 5.05061C25.5664 5.02268 25.5279 4.99468 25.4894 4.96661L20.8389 1.70029C19.7136 0.884801 19.2543 0.781553 17.4649 0.934675ZM8.13757 5.99997C6.75597 6.09272 6.44273 6.11372 5.65786 5.4776L3.6629 3.89563C3.4599 3.69088 3.56227 3.43538 4.07239 3.38464L18.0783 2.3644C19.2534 2.26203 19.8668 2.67065 20.327 3.02764L22.7297 4.76361C22.8321 4.81436 23.0867 5.11973 22.7805 5.11973L8.31607 5.98772L8.13757 5.99997ZM6.52672 24.0536V8.8463C6.52672 8.18218 6.7306 7.87594 7.34396 7.82431L23.9556 6.85483C24.5191 6.80408 24.7746 7.16108 24.7746 7.82431V22.9301C24.7746 23.5942 24.6722 24.1559 23.7508 24.2067L7.85495 25.1254C6.93534 25.1762 6.52672 24.8708 6.52672 24.0536ZM22.2196 9.66178C22.3211 10.1212 22.2196 10.5805 21.7585 10.633L20.992 10.7844V22.0122C20.327 22.3692 19.7145 22.5731 19.2035 22.5731C18.3854 22.5731 18.1798 22.3176 17.5673 21.5528L12.5571 13.6937V21.2973L14.1426 21.6552C14.1426 21.6552 14.1426 22.574 12.8634 22.574L9.33718 22.7778C9.23568 22.5731 9.33718 22.063 9.69592 21.9615L10.6147 21.7068V11.6533L9.33718 11.55C9.23568 11.0906 9.4903 10.4274 10.2069 10.3766L13.9895 10.1212L19.2035 18.0835V11.0399L17.8735 10.8876C17.772 10.325 18.1798 9.91728 18.6917 9.86653L22.2196 9.66178Z'
              fill='currentColor'
            />
          </svg>
          <h6 className='mt-4 mb-1 text-sm leading-5 font-semibold'>
            Sync with Notion
          </h6>
          <p className='text-muted-foreground my-0 text-xs leading-4'>
            Connect your Notion pages to build a workspace.
          </p>
        </div>
      </div> */}
      {step === 1 && <ChooseWorkspace />}
      {step === 2 && (
        <CreateWorkspace
          onNext={() => {
            navigate({
              to: '/workspaces/new',
              search: { 
                step: 3,
                type: undefined,
                notionKey: undefined,
                workspaceName: undefined
              }
            })
          }}
        />
      )}
      {step === 3 && <CompleteWorkspace />}
    </div>
  )
}
